// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import StatTile, { StatTileData } from './StatTile';
import styles from './StatTileGrid.module.css';

export type { StatTone, StatTileData } from './StatTile';

interface StatTileGridProps {
  tiles: StatTileData[];
}

/**
 * Hairline-divided stat tile row for the Admin Center Home dashboard. The
 * 1px gap is the grid's own background color, not a per-tile border — see
 * the Admin Center mockup.
 */
export default function StatTileGrid({ tiles }: StatTileGridProps) {
  return (
    <div className={styles.grid}>
      {tiles.map(tile => (
        <StatTile key={tile.label} {...tile} />
      ))}
    </div>
  );
}
